import { BULK_ORDER_GRID_SIGNS } from '../../common/bulkOrder/config'

/** Sticky product + column headers apply when a product has more than this many cart lines. */
export const CART_PRODUCT_STICKY_HEADER_MIN_LINES = 5

/** Delay before showing the full-panel lens-detail loader (avoids flash on fast fetches). */
export const LENS_DETAIL_LOADER_DELAY_MS = 200

/** Shared +/- options for cylinder and addition SwitchFields. */
export const SIGN_SWITCH_OPTIONS = [
  { value: BULK_ORDER_GRID_SIGNS.PLUS, text: '+' },
  { value: BULK_ORDER_GRID_SIGNS.MINUS, text: '−' },
]

/** R/L options for side SwitchField when hasSideSelection is true. */
export const SIDE_SWITCH_OPTIONS = [
  { value: 'R', text: 'R' },
  { value: 'L', text: 'L' },
]

/** Pair / Bulk mode values for the My Orders header switcher. */
export const ORDERS_MODES = {
  PAIR: 'pair',
  BULK: 'bulk',
}
